import { Injectable } from '@angular/core';
declare const wenji: IWenji;

import _union from 'lodash-es/union';
import _values from 'lodash-es/values';
import _unset from 'lodash-es/unset';

import {IWenji} from "../../libraries/interfaces/IWenji";
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class QuoteService {

    // key updated from locobook component
    public key: string;

    //var to be used in components
    public response: any = { data: {}, display: { selectedJourneys:{} }, appliedFilter:{} };

    private filters: any = {};
    private lsPrefix = sessionStorage.getItem("$instance_url");


    private initialResults: any;

    constructor (private http: HttpClient) {}


    /**
     * API function to get all the Quotes from key
     **/
    public getQuotes(): void{

            const apiUrl = sessionStorage.getItem("$instance_url") + "api/air/trips/" + this.key + "/quotes";
            const headers    = new HttpHeaders({
                'Content-Type': 'application/json',
                xtoken: localStorage.getItem(this.lsPrefix+"_token"),
                target: wenji.ui.target});
            // Create a request option
            const options = { headers };

            this.http.get(apiUrl, options)
            .subscribe((res:any) =>
                {
                    this.storeResult(res);
                },
                (error:any):any => {});

    }

    /**
     * double handle sliders filter function
     */
    public applyFilter(event: any, filterName: string, filterKey: string): void{

        const roundArray: any[] = [];

        event.forEach((num: number) => {
            roundArray.push(Math.round(num));
        });

        event = roundArray;

        if (!this.response.appliedFilter[filterName]) {
            this.response.appliedFilter[filterName] = {};
        }


        if (filterKey || filterKey !== '') {
            this.response.appliedFilter[filterName][filterKey] = event;
        } else {
            this.response.appliedFilter[filterName] = event;
        }

        this.quoteList(filterName, filterKey);

        this.updateFilters();
    }


    /**
     * Checkbox filter function
     */
    public applyFilterCheck(filterName: string, checked: any, root: boolean): void{
      const keys = Object.keys(checked);

      if(!this.response.appliedFilter[filterName]){
          this.response.appliedFilter[filterName] = {};
      }

      if(root){
          let quoteList: any[] = [];
          for(let i = 0; i < keys.length; i++){
              if(checked[keys[i]] === true){

                  quoteList = _union(quoteList, this.response.data.filter[filterName][keys[i]].quotes);
              }
          }
          this.filters[filterName ] = quoteList;
          this.response.appliedFilter[filterName]=[];
          this.response.appliedFilter[filterName][0]= _values(checked);

      }else{ //not root

          for(let i = 0; i < keys.length; i++){
            let quoteList: any[] = [];
              const keys2 = Object.keys(checked[keys[i]]);

              for(let j = 0; j < keys2.length; j++){

                  if(checked[keys[i]][keys2[j]] === true){

                      quoteList = _union(quoteList, this.response.data.filter[filterName][keys[i]][keys2[j]].quotes);
                  }
              }
              this.filters[ filterName + keys[i] ] = quoteList;
              this.response.appliedFilter[filterName]= _values(checked);
          }

      } // end else
      this.updateFilters();
    }

    public resetResult(){
        this.initialResults = null;
        _unset(this.response.display, 'bookingList');
        this.response.data = {};
    }



    /**
     *  Update the list of bookings to be displayed
     **/
    private updateFilters(): void{
        const filterKeys = Object.keys(this.filters);
        let filteredQuotes: Set<string> = null;
        const filterCount = filterKeys.length;

        for (let i = 0; i < filterCount; i++) {
            const quotes = this.filters[filterKeys[i]];

            // Creates an intersection
            filteredQuotes = new Set<string>(
                quotes.filter((quote) => !filteredQuotes || filteredQuotes.has(quote))
            );
        }

        this.response.display.bookingList = Object.keys(this.initialResults.booking)
            .filter((quote) => !filteredQuotes || filteredQuotes.has(quote));
    }

    /**
     * Update the quote list in this.filters
     * this.filters[] is a list quotes by filters
     **/
    private quoteList(filterName: string, filterKey: string): void {
        let quoteList : any[] = [];

        if(filterKey || filterKey !== ''){

            const start = this.response.appliedFilter[filterName][filterKey][0] ;
            const stop = this.response.appliedFilter[filterName][filterKey][1] ;

            const filtersegmentKeys=Object.keys(this.response.data.filter[filterName][filterKey]);


            for(let j = start; j <= stop ; j++){

              quoteList= _union(quoteList, this.response.data.filter[filterName][filterKey][filtersegmentKeys[j]].quotes);
            }
            this.filters[filterName + filterKey] = quoteList;

        }
        else{
            const start = this.response.appliedFilter[filterName][0] ;
            const stop = this.response.appliedFilter[filterName][1] ;

            const filtersegmentKeys=Object.keys(this.response.data.filter[filterName]);


            for(let j = start; j <= stop ; j++){

              quoteList= _union(quoteList, this.response.data.filter[filterName][filtersegmentKeys[j]].quotes);

            }
            this.filters[filterName] = quoteList;
        }
    }

    /**
     * used by getQuote to store response
     **/
    private storeResult(res: any){
        const result = res.data;

        this.initialResults = result;
        this.response.display.bookingList = Object.keys(result.booking) ;
        this.response.data = result;
        this.response.appliedFilter = {};
        this.filters = {};
    }
}
